<template>
  <div class="ReportDetailPagePurchase" style="padding: 20px; background-color: #fafafa" v-loading="loading">
    <div style="font-size: 20px">
      <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
        <el-breadcrumb-item :to="{ path: '/console' }">数据中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/ProductManagement' }">产品管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row>
      <el-col :span="24">
        <div style="font-size: 25px;margin-top: 15px;">
          <p>产品管理</p>
        </div>
      </el-col>
    </el-row>

    <div style="font-size: 25px;">
      <el-row style="margin-bottom: 20px" type="flex" class="row-bg" justify="space-between">
        <el-col :span="7">
          <el-select v-model="data.supplierId" filterable clearable placeholder="供应商" style="width: 100%">
            <el-option
              v-for="item in initData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="5">
          <el-select v-model="data.parentBrand" filterable clearable multiple placeholder="品牌" style="width: 100%">
            <el-option
              v-for="item in initDataSelect.parentBrand"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="5">
          <el-select v-model="data.brandName" filterable clearable multiple placeholder="系列" collapse-tags
                     style="width: 100%">
            <el-option
              v-for="item in initDataSelect.brandName"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="1.5">
          <el-button style="color: white; border-color: #FF6633; background-color: #FF6633"
                     icon="el-icon-search"
                     @click="searchProduct('button')">搜索
          </el-button>
        </el-col>

        <el-col :span="1.5">
          <el-button style="border-color: #FF6633; color:#FF6633; width: 100%" :loading="upload"
                     @click="openProductInfoUpdateDialog">产品信息管理
          </el-button>
        </el-col>

        <!--        <el-col :span="1.5">
                  <el-button style="border-color: #FF6633; color:#FF6633; width: 100%" :loading="download"
                             @click="downloadTemplate()">导出填写模板
                  </el-button>
                </el-col>

                <el-col :span="1.5">
                  <el-button style="border-color: #FF6633; color:#FF6633; width: 100%" :loading="upload"
                             @click="uploadTemplate()">上传添加产品
                    <input type="file" ref="uploadLabel" v-show="false" accept=".xls,.xlsx" @change="putExcel"/>
                  </el-button>
                </el-col>-->
      </el-row>

      <div style="height: calc(100vh - 300px);">
        <el-table
          :data="tableData"
          border
          height="100%"
          style="width: 100%">
          <el-table-column
            align="center"
            label="品牌"
            min-width="8%">
            <template slot-scope="scope">
              <div :class="[scope.row.deleteBtn ? 'gray-font' : '']">{{ scope.row.parentBrand }}</div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="系列"
            min-width="10%">
            <template slot-scope="scope">
              <div :class="[scope.row.deleteBtn ? 'gray-font' : '']">{{ scope.row.brandName }}</div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="货号"
            min-width="8%">
            <template slot-scope="scope">
              <div :class="[scope.row.deleteBtn ? 'gray-font' : '']">{{ scope.row.productCode }}</div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="品名"
            min-width="15%">
            <template slot-scope="scope">
              <span :class="[scope.row.deleteBtn ? 'gray-font' : '']">{{ scope.row.productName }}</span>
              <span v-if="scope.row.deleteBtn" class="title">
                下架中
              </span>
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            label="规格"
            min-width="6%">
            <template slot-scope="scope">
              <div :class="[scope.row.deleteBtn ? 'gray-font' : '']">{{ scope.row.specification }}</div>
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            label="零售价"
            min-width="5%">
            <template slot-scope="scope">
              <div :class="[scope.row.deleteBtn ? 'gray-font' : '']">{{ scope.row.retailPrice }}</div>
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            label="品类"
            min-width="6%">
            <template slot-scope="scope">
              <div :class="[scope.row.deleteBtn ? 'gray-font' : '']">{{ scope.row.category }}</div>
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            label="条形码"
            min-width="11%">
            <template slot-scope="scope">
              <div :class="[scope.row.deleteBtn ? 'gray-font' : '']">{{ scope.row.barcode }}</div>
            </template>
          </el-table-column>


          <el-table-column align="center" label="产品图片" min-width="7%">
            <template slot-scope="scope">
              <el-link :underline="false" style="color: #ED7043"
                       @click="previewImage = true;srcList=[scope.row.productImg]"
                       v-if="scope.row.productImg">点击查看
              </el-link>

              <el-upload v-else action="" :auto-upload="false" :on-change="(file) => { onChange(file, scope.row) }"
                         :limit="50" :show-file-list="false">
                <div style="color: #008AFF">点击上传</div>
              </el-upload>
            </template>
          </el-table-column>

          <el-table-column align="center" label="相关提成规则" min-width="7%">
            <template slot-scope="scope">
              <el-link :underline="false" style="color: #ED7043" v-if="scope.row.hasPackage"
                       @click="openPackageDialog(scope.row)">
                点击查看
              </el-link>
              <div class="gray-font" v-else>无有效提成规则</div>
            </template>
          </el-table-column>

          <el-table-column align="center" label="衍生条码" min-width="7%">
            <template slot-scope="scope">
              <el-link :underline="false" style="color: #ED7043" @click="openBarcodeDialog(scope.row)"
                       v-if="scope.row.barCodes">
                点击查看
              </el-link>
              <div class="gray-font" v-else>无</div>
            </template>
          </el-table-column>

          <el-table-column align="center" label="删除" min-width="5%">
            <template slot-scope="scope">
              <div style="cursor: pointer;color: #ED7043" :class="[scope.row.deleteBtn ? '' : 'gray-font']"
                   @click="deleteProduct(scope.row,scope.$index)">删除
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :hide-on-single-page="total == 0"
          :current-page.sync="data.currentPage"
          :page-sizes="[20, 100, 200]"
          :page-size="20"
          layout="sizes, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!--产品图片-->
    <el-dialog :visible.sync="previewImage" width="1000px" top="10%" :show-close="false">
      <el-image
        :src="srcList[0]"
        :preview-src-list="srcList">
      </el-image>
    </el-dialog>

    <!--有效提成规则-->
    <el-dialog
      title="有效提成规则"
      :visible.sync="packageDialogVisible"
      width="1025px"
      center>
      <div>
        <div style="display: flex; justify-content: space-between">
          <div style="margin-right: 20px;width: 315px">
            <div class="bold-title">产品详情</div>
            <div style="border-radius: 10px;
              border: #ededed solid;padding: 10px 10px;">
              <div class="bold-title">品牌：<span class="normal-title">{{ packageDialogData.parentBrand }}</span>
              </div>
              <div class="bold-title">系列：<span class="normal-title">{{ packageDialogData.brandName }}</span>
              </div>
              <div class="bold-title">品名：<span class="normal-title">{{ packageDialogData.productName }}</span>
              </div>
              <div class="bold-title">零售价：<span class="normal-title">{{ packageDialogData.retailPrice }}</span></div>
            </div>

            <div class="normal-title" style="margin-top: 30px">
              此处仅展示当前产品在现在及未来有效的提成规则，对于已结束的提成规则，此处不展示。
            </div>
          </div>
          <div style="width: 650px">
            <el-table
              max-height="500"
              :data="packageDialogData.tableData"
              border
              style="width: 650px">
              <el-table-column
                align="center"
                prop="packageName"
                label="规则名称"
                width="229">
              </el-table-column>
              <el-table-column
                align="center"
                label="有效期"
                width="220">
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.startTime + ' -- ' + scope.row.endTime }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                width="200"
                label="奖励方式">
                <template slot-scope="scope">
                  <div class="red-font">{{ scope.row.bonus }}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="packageDialogVisible = false">确定</el-button>
    </span>
    </el-dialog>

    <!--    衍生条码-->
    <el-dialog
      title="衍生条码"
      :visible.sync="barcodeDialogVisible"
      width="1025px"
      center>
      <div>
        <div style="display: flex; justify-content: space-between">
          <div style="margin-right: 20px;width: 315px">
            <div class="bold-title">产品详情</div>
            <div style="border-radius: 10px;
              border: #ededed solid;padding: 10px 10px;">
              <div class="bold-title">品牌：<span class="normal-title">{{ barcodeDialogData.parentBrand }}</span>
              </div>
              <div class="bold-title">系列：<span class="normal-title">{{ barcodeDialogData.brandName }}</span>
              </div>
              <div class="bold-title">品名：<span class="normal-title">{{ barcodeDialogData.productName }}</span>
              </div>
              <div class="bold-title">零售价：<span class="normal-title">{{ barcodeDialogData.retailPrice }}</span></div>
            </div>
          </div>
          <div style="width: 650px">
            <el-table
              max-height="500"
              :data="barcodeDialogData.tableData"
              border
              style="width: 650px">
              <el-table-column
                align="center"
                prop="barcode"
                label="条形码"
                width="149">
              </el-table-column>
              <el-table-column
                prop="productName"
                align="center"
                label="商品名称"
                width="200">
              </el-table-column>
              <el-table-column
                prop="specification"
                align="center"
                label="规格"
                width="100">
              </el-table-column>
              <el-table-column
                prop="productCode"
                align="center"
                label="货号"
                width="100">
              </el-table-column>
              <el-table-column
                prop="retailPrice"
                align="center"
                label="零售价"
                width="100">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="barcodeDialogVisible = false">确定</el-button>
    </span>
    </el-dialog>

    <el-dialog
      center
      title="产品信息管理"
      width="1000px"
      :visible.sync="dialog.productInfoUpdateDialogVisible"
      :before-close="closeProductInfoUpdateDialogInnerDialog"
    >
      <div>
        <div class="dialog-title">
          <div class="title-line"/>
          <div class="bold-title">品牌系列管理</div>
        </div>

        <div class="tips">1.若有新品牌/系列，请提前在下方添加</div>

        <el-table
          :data="dialog.table"
          height="250"
          border
          style="width: 100%; margin: 20px 0;">
          <el-table-column
            prop="date"
            width="150px"
            :width="flexColumnWidth('name')"
            header-align="center"
          >
            <template slot="header" slot-scope="scope">
              <div class="flex-row">
                <div>品牌</div>
                <el-button class="button-new-tag-mini" size="small"
                           @click="openProductInfoUpdateDialogInnerDialog(true, 'parentBrand')">
                  +添加
                </el-button>
              </div>
            </template>

            <template slot-scope="scope">
              <el-tag
                class="tag-parent-brand"
                size="medium">
                {{ scope.row.name }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column
            prop="name"
            label="相关系列"
            header-align="center"
          >
            <template slot-scope="scope">
              <div class="flex-row" style="justify-content: left; white-space:normal">
                <el-tag
                  class="tag-brand"
                  size="medium"
                  :key="brand"
                  v-for="brand in scope.row.children">
                  {{ brand.name }}
                </el-tag>

                <el-button class="button-new-tag" size="small" v-if="scope.row.id"
                           @click="openProductInfoUpdateDialogInnerDialog(true, 'brandName', scope.$index)">+添加系列
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div>
          <div class="dialog-title">
            <div class="title-line"/>
            <div class="bold-title">产品信息批量修改</div>
          </div>

          <div class="tips">
            1.模板中信息请完整填写，上传产品信息将立即生效。
          </div>
        </div>
      </div>

      <el-dialog
        width="30%"
        :title="'添加' + (dialog.innerDialog.type === 'parentBrand' ? '品牌' : '系列')"
        center
        :visible.sync="dialog.innerDialog.innerDialogVisible"
        append-to-body>
        <div>
          <el-input v-if="dialog.innerDialog.type === 'parentBrand'" ref="input"
                    v-model="dialog.innerDialog.inputParentBrandTagValue" placeholder="请输入品牌名"></el-input>

          <el-input v-else-if="dialog.innerDialog.type === 'brandName'" ref="input"
                    v-model="dialog.innerDialog.inputBrandNameValue"
                    placeholder="请输入系列名"></el-input>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="openProductInfoUpdateDialogInnerDialog(false, '')">取消</el-button>
          <el-button type="primary"
                     @click="dialog.innerDialog.type === 'parentBrand' ? addParentBrand() : addBrandName()">确认添加
          </el-button>
        </div>
      </el-dialog>

      <div slot="footer" class="dialog-footer">
        <div style="display: flex">
          <el-button class="plain-btn" :loading="download"
                     @click="downloadTemplate()">下载产品清单(模板)
          </el-button>

          <el-button class="orangev-btn" :loading="upload"
                     @click="uploadTemplate()">上传产品清单
            <input type="file" ref="uploadLabel" v-show="false" accept=".xls,.xlsx" @change="putExcel"/>
          </el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  deleteProduct,
  downloadTemplate,
  initData,
  queryProductBarcode,
  queryProductPackage,
  searchProduct,
  uploadProductImage,
  uploadTemplate,
  addParentBrand,
  addBrandName
} from '@/api/ProductManagement'

export default {
  data() {
    return {
      token: '',
      loading: false,

      //顶部供应商品牌系列数据选择展示
      //完整数据
      initData: {},
      //处理后品牌和系列下拉数据
      initDataSelect: {
        parentBrand: [],
        brandName: []
      },

      //顶部区域选择/提交数据
      data: {
        supplierId: '',
        parentBrand: [],
        brandName: [],
        //分页数据
        currentPage: 1,
        //分页大小
        pageSize: 20
      },

      //表单数据
      tableData: [],

      //预览图片dialog开关
      previewImage: false,
      //预览图片
      srcList: [],

      //分页
      total: 0,

      // 有效提成规则dialog开关
      packageDialogVisible: false,
      //有效提成规则dialog数据
      packageDialogData: {
        parentBrand: '',
        brandName: '',
        productName: '',
        retailPrice: '',
        tableData: []
      },

      //衍生条码
      barcodeDialogVisible: false,
      //衍生条码dialog数据
      barcodeDialogData: {
        parentBrand: '',
        brandName: '',
        productName: '',
        retailPrice: '',
        tableData: []
      },

      download: false,
      upload: false,

      //产品信息管理
      dialog: {
        table: [],
        //产品信息管理dialog开关
        productInfoUpdateDialogVisible: false,
        //内层嵌套dialog 添加品牌/系列dialog
        innerDialog: {
          //开关
          innerDialogVisible: false,
          //parentBrand, brandName
          type: '',
          //品牌信息
          inputParentBrandTagValue: '',
          //系列信息
          inputBrandNameValue: ''
        }
      }

    }
  },
  watch: {
    'data.supplierId': {
      handler(newValue, oldValue) {
        if (newValue) {
          if (oldValue !== newValue) {
            this.data.parentBrand = [];
            this.data.brandName = [];
            this.initDataSelect.parentBrand = [];
            this.initDataSelect.brandName = [];
          }

          this.initDataSelect.parentBrand = this.initData.filter(item => item.id === newValue)[0].children;
        } else {
          this.data.parentBrand = [];
          this.data.brandName = [];
          this.initDataSelect.parentBrand = [];
          this.initDataSelect.brandName = [];
        }
      },
      deep: true
    },
    'data.parentBrand': {
      handler(newValue, oldValue) {
        if (newValue.length !== 0) {
          var map = this.initDataSelect.parentBrand.filter(item => newValue.indexOf(item.id) !== -1).map(item => item.children);

          var brandName = [];
          map.forEach(item => {
            brandName = [...brandName, ...item]
          })
          this.initDataSelect.brandName = brandName;

          this.data.brandName = this.data.brandName.filter(item => {
            return this.initDataSelect.brandName.map(item => item.id).indexOf(item) !== -1
          })
        } else {
          this.initDataSelect.brandName = [];
          this.data.brandName = [];
        }
      }
    }
  },
  created() {
    this.token = localStorage.getItem('token')
    this.initPageData();
  },
  methods: {
    initPageData() {
      this.loading = true;
      initData(this.token).then(res => {
        if (res.data.code === 200) {
          this.initData = res.data.data;

          //如果只有一个供应商,自动选中供应商并查询
          if (res.data.data.length === 1) {
            this.data.supplierId = this.initData[0].id;
            this.searchProduct('button');
          }
        }
      }).catch(error => {
        let status = error.response.status;
        if (status === 500) {
          this.$notify.error({
            title: '错误',
            message: '查询失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => this.loading = false)
    },

    searchProduct(type) {
      this.loading = true;

      if (type === 'button') {
        this.data.currentPage = 1;
      }

      searchProduct(this.token, this.data).then(res => {
        if (res.data.code === 200) {
          this.tableData = res.data.data
          this.total = res.data.data[0].total
        } else if (res.data.code === 0) {
          this.$notify.error({
            title: '错误',
            message: res.data.msg,
            position: 'bottom-right'
          })
        }
      }).catch(error => {
        let status = error.response.status;
        if (status == 500) {
          this.$notify.error({
            title: '错误',
            message: '查询失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => {
        this.loading = false;
      })
    },

    handleSizeChange(val) {
      this.data.pageSize = val;
      this.data.currentPage = 1;
      this.searchProduct('pagination');
    },
    handleCurrentChange(val) {
      this.data.currentPage = val;
      this.searchProduct('pagination');
    },

    onChange(file, row) {
      const typeArr = ['image/png', 'image/jpg', 'image/jpeg'];
      const isJPG = typeArr.indexOf(file.raw.type) !== -1;
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isJPG) {
        this.$message.error('上传图片格式有误');
        this.$refs.upload.clearFiles();
        this.photoInfo.files = null;
        return;
      }
      if (!isLt3M) {
        this.$message.error('上传图片大小不能超过 3MB');
        this.$refs.upload.clearFiles();
        this.photoInfo.files = null;
        return;
      }

      // FormData 对象lo
      var formData = new FormData();
      formData.append('file', file.raw);

      this.loading = true;
      uploadProductImage(this.token, formData, row.productId, row.supplierId).then(res => {
        if (res.data.code === 200) {
          row.productImg = res.data.data;
          this.$notify.success({
            title: '成功',
            message: '上传成功',
            position: 'bottom-right'
          })
        }
        if (res.data.code === 0) {
          this.$notify.error({
            title: '错误',
            message: '上传失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).catch(error => {
        let status = error.response.status;
        if (status === 500) {
          this.$notify.error({
            title: '错误',
            message: '上传失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => this.loading = false)
    },

    //查看提成规则
    openPackageDialog(row) {
      this.packageDialogVisible = true
      this.packageDialogData.parentBrand = row.parentBrand;
      this.packageDialogData.brandName = row.brandName;
      this.packageDialogData.productName = row.productName;
      this.packageDialogData.retailPrice = row.retailPrice;
      queryProductPackage(this.token, row.productId).then(res => {
        if (res.data.code === 200) {
          this.packageDialogData.tableData = res.data.data;
        }
      })
    },

    //查看产品衍生条码
    openBarcodeDialog(row) {
      this.barcodeDialogVisible = true
      this.barcodeDialogData.parentBrand = row.parentBrand;
      this.barcodeDialogData.brandName = row.brandName;
      this.barcodeDialogData.productName = row.productName;
      this.barcodeDialogData.retailPrice = row.retailPrice;
      queryProductBarcode(this.token, row.barcode).then(res => {
        if (res.data.code === 200) {
          this.barcodeDialogData.tableData = res.data.data;
        }
      })
    },

    deleteProduct(row, index) {
      if (!row.deleteBtn) {
        return this.$confirm(`当前有提成规则的产品不允许删除`, {
          confirmButtonText: '确定',
          center: true,
          showClose: false,
          showCancelButton: false
        })
      }
      this.$confirm(`<h3><strong>确定删除产品</strong>：${row.productName}？</h3>`, {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        showClose: false
      }).then(() => {
        this.loading = true;

        deleteProduct(this.token, row.productId).then(res => {
          if (res.data.code === 200) {
            this.tableData.splice(index, 1)
            this.$notify.success({
              title: '成功',
              message: '删除成功',
              position: 'bottom-right'
            })
          } else {
            this.$notify.error({
              title: '失败',
              message: '删除失败，请联系管理员',
              position: 'bottom-right'
            })
          }
        }).catch(error => {
          let status = error.response.status;
          if (status === 500) {
            this.$notify.error({
              title: '错误',
              message: '删除失败，请联系管理员',
              position: 'bottom-right'
            })
          }
        }).finally(() => this.loading = false)
      })
    },
    downloadTemplate() {
      if (!this.data.supplierId) {
        return this.$notify.error({
          title: '错误',
          message: '请选择供应商',
          position: 'bottom-right'
        })
      }

      var data = JSON.parse(JSON.stringify(this.data));

      data.supplierName = this.initData.find(item => item.id === this.data.supplierId).name;
      data.parentBrand = [];
      data.brandName = [];

      this.download = true;
      downloadTemplate(this.token, data).then(res => {
        if (res.status !== 200) {
          return this.$notify.error(`通路活动[${this.reportInit[this.formInfo.type].find(activityItem => activityItem.id === item).title}]无活动数据`)
        }
        let blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
        let url = window.URL.createObjectURL(blob)
        let link = document.createElement('a')
        link.href = url
        let fileName = decodeURI(res.headers['filename'])
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
      }).finally(() => this.download = false)

    },
    uploadTemplate() {
      if (!this.data.supplierId) {
        return this.$notify.error({
          title: '错误',
          message: '请选择供应商',
          position: 'bottom-right'
        })
      }
      this.$refs.uploadLabel.click()
    },
    putExcel() {
      this.loading = true;
      let inputDOM = this.$refs.uploadLabel
      let file = inputDOM.files[0]
      let formData = new FormData();
      formData.append("file", file)

      uploadTemplate(this.token, formData, this.data.supplierId).then(r => {
        let {data} = r
        if (data.code === 200) {
          this.$notify.success({
            title: '成功',
            message: '上传成功',
            position: 'bottom-right'
          })
        }
        if (data.code === 0)
          this.$notify.error({
            title: '错误',
            message: data.msg,
            position: 'bottom-right'
          })
      }).catch(error => {
        let status = error.response.status;
        if (status === 500) {
          this.$notify.error({
            title: '错误',
            message: '上传失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => {
        this.loading = false
        this.$refs.uploadLabel.value = ''
      })
    },

    //打开产品信息管理dialog
    openProductInfoUpdateDialog() {
      //判断是否选择供应商
      if (!this.data.supplierId) {
        return this.$notify.error({
          title: '提示',
          message: '请先选择供应商',
          position: 'bottom-right'
        })
      }
      this.closeProductInfoUpdateDialogInnerDialog();

      this.dialog.table = this.initTable();

      //开启dialog
      this.dialog.productInfoUpdateDialogVisible = true;
    },

    //打开产品信息管理dialog内部dialog(添加品牌/系列dialog)
    openProductInfoUpdateDialogInnerDialog(status, type, index) {
      this.dialog.innerDialog.innerDialogVisible = status;
      this.dialog.innerDialog.type = type;
      this.dialog.innerDialog.inputParentBrandTagValue = '';
      this.dialog.innerDialog.inputBrandNameValue = '';

      if (index != null) {
        this.dialog.innerDialog.inputParentBrandTagValue = this.dialog.table[index].id;
      }

      if (status) {
        this.$nextTick(() => {
          this.$refs.input.focus()
        })
      }
    },

    //初始化表格数据
    initTable() {
      //选中的供应商
      var supplierId = this.data.supplierId

      if (!supplierId)
        return;

      //根据选中的供应商获取品牌列表数据
      var parentBrandList = JSON.parse(JSON.stringify(this.initData.filter(item => item.id === supplierId)[0].children));

      return parentBrandList;
    },
    //关闭产品信息管理dialog
    closeProductInfoUpdateDialogInnerDialog() {
      this.dialog = {
        table: [],
        productInfoUpdateDialogVisible: false,
        innerDialog: {
          innerDialogVisible: false,
          type: '',
          inputParentBrandTagValue: '',
          inputBrandNameValue: ''
        }
      }

      var data = JSON.parse(JSON.stringify(this.data));
      this.data = null;
      this.data = data;
    },

    //添加品牌
    addParentBrand() {
      if (!this.data.supplierId || !this.data.supplierId.length) {
        return this.$message.error("请选择供应商")
      }

      //添加品牌信息
      if (!this.dialog.innerDialog.inputParentBrandTagValue || !this.dialog.innerDialog.inputParentBrandTagValue.length)
        return this.$message.error("请输入品牌名称");

      var param = {
        supplierId: this.data.supplierId,
        parentBrand: this.dialog.innerDialog.inputParentBrandTagValue
      }

      addParentBrand(this.token, param).then(res => {
        if (res.data.code == 200) {
          this.initData[this.initData.findIndex(item => item.id === this.data.supplierId)].children.push(res.data.data);
          this.openProductInfoUpdateDialog();
          this.$message.success("添加品牌成功");
        } else {
          this.$message.error("添加品牌失败")
        }
      }).catch(() => {
        this.$message.error("添加品牌失败")
      }).finally(() => {
      })
    },

    //添加系列
    addBrandName() {
      if (!this.dialog.innerDialog.inputParentBrandTagValue || !this.dialog.innerDialog.inputParentBrandTagValue.length) {
        return this.$message.error("请选择品牌");
      }

      if (!this.dialog.innerDialog.inputBrandNameValue || !this.dialog.innerDialog.inputBrandNameValue.length) {
        return this.$message.error("请输入系列名称");
      }

      var param = {
        supplierId: this.data.supplierId,
        parentBrand: this.dialog.innerDialog.inputParentBrandTagValue,
        brandName: this.dialog.innerDialog.inputBrandNameValue,
      }

      addBrandName(this.token, param).then(res => {
        if (res.data.code == 200) {
          var brandChildren = this.initData[this.initData.findIndex(item => item.id === this.data.supplierId)].children;
          brandChildren[brandChildren.findIndex(item => item.id == this.dialog.innerDialog.inputParentBrandTagValue)].children.push(res.data.data);
          this.openProductInfoUpdateDialog();
          this.$message.success("添加系列成功");
        } else {
          this.$message.error("添加系列失败")
        }
      }).catch(() => {
        this.$message.error("添加系列失败")
      }).finally(() => {
      })
    },

    /**
     * 遍历列的所有内容，获取最宽一列的宽度
     * @param arr
     */
    getMaxLength(arr) {
      return arr.reduce((acc, item) => {
        if (item) {
          const calcLen = this.getTextWidth(item)
          if (acc < calcLen) {
            acc = calcLen
          }
        }
        return acc
      }, 0)
    },
    /**
     * 使用span标签包裹内容，然后计算span的宽度 width： px
     * @param valArr
     */
    getTextWidth(str) {
      let width = 0
      const html = document.createElement('span')
      html.innerText = str
      html.className = 'getTextWidth'
      document.querySelector('body').appendChild(html)
      width = document.querySelector('.getTextWidth').offsetWidth
      document.querySelector('.getTextWidth').remove()
      return width
    },
    /**
     * el-table-column 自适应列宽
     * @param prop_label: 表名
     */
    flexColumnWidth(prop) {
      // 1.获取该列的所有数据
      const arr = this.dialog.table.map(x => x[prop])
      // 2.计算每列内容最大的宽度 + 表格的内间距（依据实际情况而定）
      var width = (this.getMaxLength(arr) + 25);
      return (width < 120 ? 120 : width) + 'px'
    }
  }
}
</script>

<style scoped>
.ReportDetailPagePurchase {
  font-family: PingFangSC-Regular, 微软雅黑;
}

.el-select .el-select-dropdown__list {
  list-style: none;
  padding: 0px 0;
  margin: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.title {
  margin-left: 10px;
  border-radius: 3px;
  display: inline-block;
  line-height: 20px;
  height: 20px;
  background: rgb(151, 151, 151);
  color: white;
  font-size: 10px;
  padding: 0 2px;
}

.gray-font {
  color: #D8D8D8 !important;
}

.bold-title {
  color: #979797;
  font-weight: 600;
}

.normal-title {
  color: #979797;
  font-weight: 400;
}

.red-font {
  color: #F55A58;
}

>>> .el-dialog__title {
  color: #ED7043;
  font-weight: 600;
  font-size: 20px;
}

.tag-brand {
  background: #F5F7FA !important;
  color: #979797 !important;;
  border-color: #C1C4CB !important;
  height: 30px;
  line-height: 28px;
}

.tag-parent-brand {
  background: #FFEFDB !important;
  color: #FF6633 !important;;
  border-color: #FF6633 !important;
  width: 100%;
  text-align: center;
  height: 30px;
  line-height: 28px;
}

.button-new-tag {
  width: 70px;
  height: 30px;
  line-height: 28px;
  padding: 0;
  border-color: #FF6633;
  color: #FF6633;
  box-sizing: border-box;
}

.button-new-tag-mini {
  width: 45px;
  height: 28px;
  line-height: 28px;
  padding: 0;
  border-color: #FF6633;
  color: #FF6633;
  box-sizing: border-box;
}

.orangev-btn {
  background-color: #FF6633;
  color: white;
  width: 100%;
}

.plain-btn {
  border-color: #FF6633;
  color: #FF6633;
  width: 100%;
}

.tips {
  color: #979797;
  font-size: 14px;
  line-height: 25px;
}

.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  justify-content: center;
  flex-wrap: wrap;
}

.dialog-title {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
}

.dialog-title .title-line {
  width: 5px;
  background: #ED7043;
  margin-right: 10px;
}

.dialog-title .bold-title {
  font-weight: 600;
  color: #000000;
  font-size: 18px;
}
</style>
